<template>
  <div class="p-context-menu-file-preview-tile">
    <div class="divide-gray-lighten-2 divide-y">
      <PContextMenuItem @click="downloadFile">
        <FontAwesomeIcon :icon="['fas', 'download']" />
        <span>Downloaden</span>
      </PContextMenuItem>
      <PContextMenuItem
        v-if="modelValue.file.isImage()"
        :loading="roateLoader"
        @click="rotateFile()"
      >
        <FontAwesomeIcon :icon="['fas', 'rotate-right']" />
        <span>Roteren</span>
        <template #submenu>
          <PContextMenuItem :loading="roateLoader" @click="rotateFile(90)">
            Roteer 90º
          </PContextMenuItem>
          <PContextMenuItem :loading="roateLoader" @click="rotateFile(180)">
            Roteer 180º
          </PContextMenuItem>
          <PContextMenuItem :loading="roateLoader" @click="rotateFile(270)">
            Roteer 270º
          </PContextMenuItem>
        </template>
      </PContextMenuItem>
      <PContextMenuItem class="hover:text-error" @click="removeFileRelation">
        <FontAwesomeIcon :icon="['fas', 'trash-can']" />
        <span>Verwijderen</span>
      </PContextMenuItem>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, inject, ref } from "vue"
import { FileRelation } from "@/models/file/file-relation.model"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

import PContextMenuItem from "@/components/overlay/PContextMenuItem.vue"
import { FileController } from "@/controllers/file-controller"

const modelValue = defineModel<FileRelation>({ required: true })

const emit = defineEmits(["closePreview", "reloadPreview", "delete"])

const instance = getCurrentInstance()

const fileController: FileController = inject("fileController")!

async function removeFileRelation() {
  if (modelValue.value !== null) {
    emit("delete", modelValue.value)
    closeMenu()
  }
}

async function downloadFile() {
  if (modelValue.value !== null) {
    const blob = await fetch(modelValue.value.file.url).then((res) => res.blob())
    const objUrl = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.download = modelValue.value.file.originalName
    a.href = objUrl
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(objUrl)
  }
  closeMenu()
}

let accumulatedDegreesAfterLastSync = 0
const roateLoader = ref(false)

async function rotateFile(degrees = 90) {
  if (modelValue.value !== null) {
    roateLoader.value = true

    accumulatedDegreesAfterLastSync = (accumulatedDegreesAfterLastSync + degrees) % 360

    await fileController.rotateFile(modelValue.value.file, accumulatedDegreesAfterLastSync)
    roateLoader.value = false
  }
  closeMenu()
  reloadPreview()
}
// Closes the Context Menu
function closeMenu() {
  instance!.parent!.emit("closeMenu")
}
function reloadPreview() {
  emit("reloadPreview")
}
</script>

<style scoped></style>
